import { render, staticRenderFns } from "./UpdateProvider.vue?vue&type=template&id=2e93dc73&scoped=true"
import script from "./UpdateProvider.vue?vue&type=script&lang=js"
export * from "./UpdateProvider.vue?vue&type=script&lang=js"
import style0 from "./UpdateProvider.vue?vue&type=style&index=0&id=2e93dc73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93dc73",
  null
  
)

export default component.exports